export enum FastSendTemplateCategory {
  Otp = 1,
  Informational = 2,
  OrderStatus = 3,
  Other = 100,
}
